import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ProfileViewModel } from 'src/app/data/api/models';
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'szz-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  model = input.required<ProfileViewModel>();
  /** Drives the menu button's aria-expanded on narrow screens. */
  sidebarOpen = input(false);
  logout = output<void>();
  toggleSidebar = output<void>();

  onLogout(): void {
    this.logout.emit();
  }
}
